import { IconButton, Tooltip } from "@mui/material";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import { useTranslation } from "react-i18next";

const ThemeToggle = ({ mode, onToggle }) => {
  const isDark = mode === "dark";
  const { t } = useTranslation();

  return (
    <Tooltip title={t(isDark ? "platform.theme.light" : "platform.theme.dark")}>
      <IconButton
        onClick={onToggle}
        aria-label={t("topbar.toggleTheme")}
        sx={{
          width: 36,
          height: 36,
        }}
      >
        {isDark ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;
